module.exports = __webpack_public_path__ + "img/file_attached_disabled.35b52e5c.svg";